<h2 mat-dialog-title>Mis Solicitudes</h2>
<mat-dialog-content *ngIf="cargado">
        <mat-list>
                <mat-list-item *ngFor="let solicitud of solicitudes | orderBy: '-solicitud.fieldData.MarcaFechaYHoraCreación'" (click)="openInfo(solicitud.fieldData)" [ngClass]="castEstado(solicitud.fieldData.Estado)">
                  <mat-icon mat-list-icon>folder</mat-icon>
                  <h4 mat-line>Solicitud expediente: {{solicitud.fieldData.recordId}}</h4>
                  <p mat-line>Fecha: {{solicitud.fieldData['MarcaFechaYHoraCreación'] | date:'dd/MM/yyyy' }}</p>
                  <p mat-line> Estado: {{castEstado(solicitud.fieldData.Estado)}} </p>

                </mat-list-item>
            
              </mat-list>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" >Cerrar</button>
        </mat-dialog-actions>
